module.exports = __webpack_public_path__ + "img/glxt.307c84f6.svg";